// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2Cn04","title":"Images90_title__nPPOd","images":"Images90_images__1W2yw"};